// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 392) return "static/chunks/392-146e2fb6cc983d7d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"284":"ccec489b6952ac9b","631":"9ece5d2a115592e9","931":"591c978847cb86fd"}[chunkId] + ".js";
};